module.exports = fox._r("images/spring18/gift-59.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/spring18/gift-59.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/spring18/gift-59.png
// module id = 260
// module chunks = 4